import noBlogImage from "../assets/no-blog-image.webp";
import BlankProfileImage from "./../assets/fallback/artist_fallback.webp";
import Badge from "./Badge";

const BlogpostSummery = ({ post, index }) => {
  const altText = "Omslagsbild för inlägget: " + post.title;
  const postedByType = String(post?.posted_by_type || "").toLowerCase();
  const postedByBasePath = ["organizer", "organiser", "organization"].includes(
    postedByType,
  )
    ? "/orgs"
    : "/music";
  const postedByUrl = `${postedByBasePath}/${post.posted_by_slug}`;
  const postUrl = `/music/${post.posted_by_slug}/blog/${post.slug}`;
  const profileImage = post.posted_by_profile_image
    ? post.posted_by_profile_image
    : BlankProfileImage;

  if (post) {
    return (
      <div
        key={index}
        className="w-full max-w-full bg-[#131313] border border-white/10 shadow-lg rounded-2xl overflow-hidden p-6 hover:border-white/20 transition-all duration-300"
      >
        <div className="w-full h-auto flex flex-col">
          {/* Title and Post Type */}
          <div className="mb-4">
            <div className="flex justify-between items-center gap-4">
              <a href={postUrl} className="flex-1 min-w-0">
                <h4 className="font-extrabold text-xl sm:text-2xl text-white uppercase tracking-wide truncate hover:text-[#0047ff] transition-colors">
                  {post.title}
                </h4>
              </a>
              <div className="flex-shrink-0">
                <Badge
                  text={post.post_type}
                  type={
                    post.post_type === "Blogg" ? "post-blog" : "post-news"
                  }
                  href="/blogs"
                />
              </div>
            </div>
          </div>
          {/* Image & Text */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Image */}
            <div className="aspect-[16/9] overflow-hidden rounded-xl border border-white/5 relative">
              <a href={postUrl} className="block w-full h-full">
                {post.image_main ? (
                  <img
                    className="object-cover w-full h-full transition-transform duration-500 hover:scale-105"
                    src={post.image_main}
                    alt={altText}
                  />
                ) : (
                  <div className="w-full h-full bg-[#181818] flex items-center justify-center relative">
                    <p className="font-bold text-xs text-stone-600 uppercase tracking-widest">
                      INGEN BILD
                    </p>
                    <img
                      className="absolute inset-0 w-full h-full object-cover opacity-10 grayscale"
                      src={noBlogImage}
                      alt="Det finns ingen bild för inlägget"
                    />
                  </div>
                )}
              </a>
            </div>
            {/* Text */}
            <div className="flex flex-col justify-between overflow-hidden">
              <p className="text-sm text-stone-300 leading-relaxed line-clamp-6">{post.content}</p>
            </div>
          </div>

          {/* Footer */}
          <div className="flex justify-between items-center mt-6 pt-4 border-t border-white/5">
            <div>
              <a
                href={postedByUrl}
                className="text-xs font-bold text-white hover:text-[#0047ff] transition-colors flex items-center"
              >
                <img
                  className="w-8 h-8 rounded-full mr-2.5 border border-white/10"
                  src={profileImage}
                  alt={`Profile image for ${post.posted_by_name}`}
                />
                {post.posted_by_name}
              </a>
            </div>
            <div>
              <p className="text-[10px] text-stone-500 font-semibold">{post.formatted_created_at}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default BlogpostSummery;
